import React from 'react';
import { useMatches, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../store';

import { setRouterHistory } from '../../store/slices/application';
import evBusMain from '../../utils/evbus';

const RouteChangeHandler = () => {
  const uriMatches = useMatches();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [routeState, setRouteState] = React.useState({
    pages: 0,
    currentPath: '',
    pagesHistory: [],
  });

  const handleAction = React.useCallback(
    (data: any, event: string) => {
      //console.log('RouteChangeHandler handleAction', data, event);
      navigate(data.url);
    },
    [navigate],
  );

  React.useEffect(() => {
    evBusMain.on('route-change', handleAction);

    return () => {
      evBusMain.remove('route-change', handleAction);
    };
  }, [navigate, handleAction]);

  React.useEffect(() => {
    if (uriMatches && uriMatches.length) {
      const uriMatch = uriMatches[uriMatches.length - 1];
      const pathname = uriMatch.pathname + window.location.hash;

      setRouteState((prev: any) => {
        if (prev.currentPath !== pathname) {
          const newState = {
            pages: prev.pages + 1,
            currentPath: pathname,
            pagesHistory: [pathname, ...prev.pagesHistory].slice(0, 50),
          };
          return newState;
        }
        return prev;
      });
    }
  }, [uriMatches]);

  React.useEffect(() => {
    dispatch(setRouterHistory(routeState));
  }, [dispatch, routeState]);

  return null;
};

export default RouteChangeHandler;
